type PatientIdentity = {
  _id?: string;
  patient_id?: string;
  patient_phone?: string;
  file_number?: string;
  file_id?: string;
  doctor_id?: string;
};

export const buildPatientHistoryParams = (
  patient: PatientIdentity,
  clinicScopeIds: string[] = [],
) => {
  const params: Record<string, string | number> = {
    patient_id: patient.patient_id || '',
    doctor_id: patient.doctor_id || '',
    page: 1,
    limit: 9999,
  };

  if (patient._id) params.mongo_id = patient._id;
  if (patient.patient_phone) params.patient_phone = patient.patient_phone;
  const fileNumber = patient.file_number || patient.file_id;
  if (fileNumber) params.file_number = String(fileNumber).trim();
  if (clinicScopeIds.length > 0) {
    params.clinic_ids = clinicScopeIds.join(',');
    params.use_clinic_scope = 'true';
  }

  return params;
};

export const buildComplaintIdentityPayload = (
  patient: PatientIdentity,
  sourceMongoId?: string,
) => ({
  patient_id: patient.patient_id || '',
  doctor_id: patient.doctor_id || '',
  patient_mongo_id: sourceMongoId || patient._id || '',
});
